import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { StatCard } from '../components/StatCard';
import { SongCard } from '../components/SongCard';
import { tierInfo } from '../data/mockData';

export function DashboardPage() {
  const { currentUser, songs, notifications, storageMb } = useApp();
  const username = currentUser?.username ?? 'Creator';
  const mySongs = songs.filter((s) => s.ownerId === currentUser?.id);
  const recent = mySongs.slice(0, 3);
  const tier = tierInfo.find((t) => t.id === currentUser?.tier) ?? tierInfo[0];
  const unread = notifications.filter((n) => !n.read);

  return (
    <div className="grid">
      {/* Welcome + bg */}
      <div
        className="card"
        style={{
          background: 'linear-gradient(120deg, rgba(9,9,9,0.7), rgba(20,20,20,0.5))',
        }}
      >
        <div className="section-title">Welcome back</div>
        <div className="welcome">
          I AM <span>{username}</span>
        </div>
        <div className="muted mb-16" style={{ marginTop: 4 }}>
          {tier.name} plan · {tier.tagline}
        </div>
        <div className="flex wrap gap-8">
          <Link to="/app/studio" className="btn btn-primary btn-sm">Create Song</Link>
          <Link to="/app/studio" className="btn btn-gold btn-sm">Upload Track</Link>
          <Link to="/app/library" className="btn btn-outline btn-sm">View Library</Link>
          <Link to="/app/arena" className="btn btn-outline btn-sm">Enter Battle</Link>
          <Link to="/app/messages" className="btn btn-outline btn-sm">Messages</Link>
          <Link to="/app/live" className="btn btn-outline btn-sm">Live Battle</Link>
        </div>
      </div>

      {/* Stats */}
      <div className="grid cols-4">
        <StatCard label="Your Songs" value={mySongs.length} sub={`${mySongs.filter((s) => s.privacy === 'PUBLIC_APPROVED').length} on The Wave`} />
        <StatCard label="Current Plan" value={tier.name} accent={tier.accent} sub={tier.price + '/mo'} />
        <StatCard label="Storage Used" value={`${storageMb} MB`} sub={`of ${tier.limits.storage}`} />
        <StatCard label="Unread Alerts" value={unread.length} sub="notifications" accent={unread.length ? '#df3f3f' : undefined} />
      </div>

      {/* Recent + battle + notifications */}
      <div className="grid cols-2">
        <div className="card">
          <div className="flex-between mb-16">
            <div className="section-title" style={{ margin: 0 }}>Recent Songs</div>
            <Link to="/app/library" className="btn btn-ghost btn-sm">All →</Link>
          </div>
          {recent.length === 0 ? (
            <div className="empty">No songs yet. Open Studio to upload your first track.</div>
          ) : (
            <div className="grid cols-3">
              {recent.map((s) => (
                <SongCard key={s.id} song={s} />
              ))}
            </div>
          )}
        </div>

        <div className="card">
          <div className="section-title">Battle Status</div>
          <div className="flex gap-12 mb-16" style={{ alignItems: 'center' }}>
            <div className="chip chip-gold">The Arena</div>
            <div className="muted">View current battles and entry deadlines</div>
          </div>
          <p className="muted" style={{ fontSize: 14 }}>
            One eligible original track per entrant. Hip-Hop genre. 70% judge
            score / 30% verified audience vote. No cash prizes — win Tier 4
            memberships, badges, and promotion.
          </p>
          <Link to="/app/arena" className="btn btn-primary btn-sm mt-16">Go to The Arena</Link>
        </div>
      </div>

      {/* Notifications + promotion */}
      <div className="grid cols-2">
        <div className="card">
          <div className="section-title">Notifications</div>
          {unread.length === 0 ? (
            <div className="muted">You're all caught up.</div>
          ) : (
            unread.slice(0, 3).map((n) => (
              <div key={n.id} className="mb-8">
                <strong>{n.title}</strong>
                <div className="muted" style={{ fontSize: 13 }}>{n.body}</div>
              </div>
            ))
          )}
          <Link to="/app/notifications" className="btn btn-ghost btn-sm mt-16">View all</Link>
        </div>

        <div className="card" style={{ borderColor: 'rgba(201,162,39,0.4)' }}>
          <div className="section-title gold">Promotion Status</div>
          <p style={{ fontSize: 14 }}>
            Approved tracks appear on The Wave. Check your notifications for promotion updates.
          </p>
          <div className="muted" style={{ fontSize: 12.5 }}>
            Promotion means IAMMUZIK commits to actions — not guaranteed
            streams, followers, sales, or career outcomes.
          </div>
        </div>
      </div>
    </div>
  );
}
